import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Button, BUTTON_SIZES } from 'shared/UI/Button'
import { Input } from 'shared/UI/Input'
import { PrivacyMessage } from 'shared/Components/PrivacyMessage'
import { getUrlParamValue } from 'shared/helpers/UrlHelper'
import { useTranslation, TRANSLATION_VALUE_KEYS, TRANSLATION_KEYS } from 'shared/customHooks'
import { ACCESSIBILITY_CLASSES } from 'shared/helpers/AccessibilityHelper'
import Validator from 'validatorjs'
import isEmpty from 'lodash/isEmpty'

import './style.css.scss'

const InputEmail = (props) => {
  const [email, setEmail] = useState(getUrlParamValue(window.location.href, 'email') || '')
  const [errorMessage, setErrorMessage] = useState('')
  const [sendButtonDisabled, setSendButtonDisabled] = useState(!isEmpty(props.privacyMessage))
  const { getTranslation } = useTranslation(TRANSLATION_KEYS.twoFAPage, props.locale)

  const emailValidationRules = {
    email: 'required|email'
  }

  const invalidEmailError = getTranslation(TRANSLATION_VALUE_KEYS.emailField)
  const requiredEmailError = getTranslation(TRANSLATION_VALUE_KEYS.requiredSingleField, {
    fieldName: getTranslation(TRANSLATION_VALUE_KEYS.email)
  })

  const handleEmailConfirm = () => {
    const emailWithoutSpaces = email.trim()

    Validator.setMessages(Validator.getDefaultLang(), {
      ...Validator.getMessages(Validator.getDefaultLang()),
      required: requiredEmailError,
      email: invalidEmailError
    })

    const validation = new Validator({ email: emailWithoutSpaces }, emailValidationRules)
    if (validation.fails()) {
      setErrorMessage(validation.errors.first('email'))
    } else {
      setErrorMessage('')
      props.onEmailConfirm(emailWithoutSpaces)
    }
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    handleEmailConfirm()
  }

  const errorMessageToShow = errorMessage || props.errorMessage

  const colorStyle = (color)=>{
    return isEmpty(color) ? null : { color: color }
  }

  const { title, subtitle } = props.pageProperties

  return (
    <div className="by-email-auth-input input-email">
      <p style={{...colorStyle(title.color)}} className="title">{isEmpty(title.text) ? getTranslation(TRANSLATION_VALUE_KEYS.twoFAPageTitle) : title.text }</p>
      <form
        className="content"
        onSubmit={handleSubmit}>
        <p style={{...colorStyle(subtitle.color)}} className="instructions">
          {isEmpty(subtitle.text) ? getTranslation(TRANSLATION_VALUE_KEYS.twoFAPageDescription) : subtitle.text}
        </p>
        <Input
          placeholder= {getTranslation(TRANSLATION_VALUE_KEYS.enterEmail)}
          onChange={e => setEmail(e.target.value)}
          autoFocus={true}
          value={email || ''}
          withErrorMessage={true}
          errorMessage={errorMessageToShow} />
        { props.privacyMessage?.message &&
        <div>
          <hr/>
          <PrivacyMessage
            config={props.privacyMessage}
            setSendButtonDisabled={setSendButtonDisabled} />
        </div>
        }
        <Button
          className={`submit-email ${ACCESSIBILITY_CLASSES.main} `}
          onClick={handleEmailConfirm}
          size={BUTTON_SIZES.medium}
          disabled={sendButtonDisabled} >
          {getTranslation(TRANSLATION_VALUE_KEYS.sendCodeInitial)}
        </Button>
      </form>
    </div>
  )
}

InputEmail.propTypes = {
  onEmailConfirm: PropTypes.func.isRequired,
  errorMessage: PropTypes.string,
  privacyMessage: PropTypes.object,
  locale: PropTypes.string.isRequired,
  pageProperties: PropTypes.object.isRequired
}

InputEmail.defaultProps = {
  errorMessage: ''
}

export default InputEmail
